import {ISelectedRegionEstimatedPrice} from "../../actions/fetch_selected_region_estimated_price";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";

export enum ParagraphType {
    TEXT,
    LIST,
    TABLE
}

export enum TextType {
    TEXT,
    LINK
}

export type ILocationGenericParagraphSingleText =
    | string
    | {
          type: TextType.LINK;
          href: string;
          text: string;
      };

export interface ILocationGenericParagraphText {
    type: ParagraphType.TEXT;
    text: ILocationGenericParagraphSingleText | ILocationGenericParagraphSingleText[];
}

export interface ILocationGenericParagraphList {
    type: ParagraphType.LIST;
    text: string[];
}

export interface ILocationGenericParagraphTable {
    type: ParagraphType.TABLE;
    caption: string;
    captionHidden?: string;
    headers: string[];
    rows: string[][];
}

export type ILocationGenericParagraph = ILocationGenericParagraphText | ILocationGenericParagraphList | ILocationGenericParagraphTable;

export interface ILocationGenericSubsection {
    headline: string;
    paragraphs: ILocationGenericParagraph[];
}

export interface ILocationGenericSection {
    headline: string;
    description?: string;
    updateDate?: string;
    paragraphs: ILocationGenericParagraph[];
    subsections?: ILocationGenericSubsection[];
}

export interface ILocationGenericSectionProps {
    region: ISelectedRegion;
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
}
import {ISelectedRegionEstimatedPrice} from "../../actions/fetch_selected_region_estimated_price";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";

export enum ParagraphType {
    TEXT,
    LIST,
    TABLE
}

export enum TextType {
    TEXT,
    LINK
}

export type ILocationGenericParagraphSingleText =
    | string
    | {
          type: TextType.LINK;
          href: string;
          text: string;
      };

export interface ILocationGenericParagraphText {
    type: ParagraphType.TEXT;
    text: ILocationGenericParagraphSingleText | ILocationGenericParagraphSingleText[];
}

export interface ILocationGenericParagraphList {
    type: ParagraphType.LIST;
    text: string[];
}

export interface ILocationGenericParagraphTable {
    type: ParagraphType.TABLE;
    caption: string;
    captionHidden?: string;
    headers: string[];
    rows: string[][];
}

export type ILocationGenericParagraph = ILocationGenericParagraphText | ILocationGenericParagraphList | ILocationGenericParagraphTable;

export interface ILocationGenericSubsection {
    headline: string;
    paragraphs: ILocationGenericParagraph[];
}

export interface ILocationGenericSection {
    headline: string;
    description?: string;
    updateDate?: string;
    paragraphs: ILocationGenericParagraph[];
    subsections?: ILocationGenericSubsection[];
}

export interface ILocationGenericSectionProps {
    region: ISelectedRegion;
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
}
